import { render, staticRenderFns } from "./CompareLedger.vue?vue&type=template&id=0e96858c&scoped=true&"
import script from "./CompareLedger.vue?vue&type=script&lang=js&"
export * from "./CompareLedger.vue?vue&type=script&lang=js&"
import style0 from "./CompareLedger.vue?vue&type=style&index=0&id=0e96858c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96858c",
  null
  
)

export default component.exports